import React from "react";
import {Col, FormGroup, Input} from "reactstrap";
import debounce from "../../utils/debounce"

const AdminSearechBox = (props) => {
    const {queryPersist,setLoadingData} = props;

    const searchMedicineOnChange = debounce(value => {
        queryPersist("search",value);
    }, 1000);

    return (
        <div className="admin_search_container">
            <div className="search_bar col-md-5">
                <Input
                    type="text"
                    name="search"
                    placeholder="Search here..."
                    onChange={(e) => searchMedicineOnChange(e.target.value)}
                />
            </div>
            <div className="filter_item">
                <div>
                    <FormGroup row className="user_status_field">
                        <Col className="p-0">
                            <Input
                                className="user_action pe-5"
                                name="select"
                                type="select"
                                onChange={(e) => {
                                    setLoadingData(true);
                                    queryPersist("status", e.target.value)
                                }}
                            >
                                <option value="">
                                    All
                                </option>
                                <option value={1}>
                                    Active
                                </option>
                                <option value={2}>
                                    Inactive
                                </option>
                            </Input>
                        </Col>
                    </FormGroup>
                </div>
                <div>
                    <FormGroup row className="user_status_field">
                        <Col className="gap-2 ">
                            <Input
                                className="user_action pe-5"
                                name="select"
                                type="select"
                                defaultValue={50}
                                onChange={(e) => {
                                    setLoadingData(true);
                                    queryPersist("limit", e.target.value)
                                }}
                            >
                                <option value={10}>
                                    10
                                </option>
                                <option value={20}>
                                    20
                                </option>
                                <option value={50}>
                                    50
                                </option>
                                <option value={100}>
                                    100
                                </option>
                            </Input>
                        </Col>
                    </FormGroup>
                </div>
            </div>

        </div>
    )
}

export default AdminSearechBox;